// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LockFilledSvg from "@ant-design/icons-svg/es/asn/LockFilled";
import AntdIcon from '../components/AntdIcon';

var LockFilled = function LockFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LockFilledSvg
  }));
};

LockFilled.displayName = 'LockFilled';
export default React.forwardRef(LockFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/LockFilled.js
// module id = 1431
// module chunks = 0